module.exports = __webpack_public_path__ + "static/media/4.2eee7cfd.jpg";